// from swagger docs for POST and PUT
import { UUID } from 'types/shared/UUID';
import { eWireDisbursementsCategories } from '../IEscrowWireDisbursementsData';
import { IWireDisbursementFormData } from '../wires/IWireDisbursementFormData';
import { IHoldbackDisbursement } from '../IHoldbackDisbursement';

export interface ICreateWireDisbursementRequest extends IHoldbackDisbursement {
  amountCents?: number;
  beneficiary?: string;
  category?: eWireDisbursementsCategories;
  memo?: string;
  routingNumber?: string;
  accountNumber?: string;
  cdItemV3Id?: string;
  version: string;
}

export interface IUpdateWireDisbursementRequest extends ICreateWireDisbursementRequest {
  id: UUID;
}

export type IWireDisbursementRequestProps = Pick<
  IWireDisbursementFormData,
  | 'amountCents'
  | 'beneficiary'
  | 'category'
  | 'memo'
  | 'accountNumber'
  | 'routingNumber'
  | 'statementFeeId'
  | 'holdback'
  | 'holdbackProperties'
>;

export const convertWireDisbursementFormDataToWireDisbursementRequest = (
  {
    amountCents,
    beneficiary,
    category,
    memo,
    accountNumber,
    routingNumber,
    statementFeeId,
    holdback,
    holdbackProperties,
  }: IWireDisbursementRequestProps,
  version: 'v1' | 'v2'
) => ({
  //validation makes sure that amountCents is not null.
  amountCents,
  beneficiary,
  category,
  memo,
  accountNumber,
  routingNumber,
  statementFeeId,
  version,
  holdback,
  holdbackProperties,
});

export const convertWireDisbursementFormDataToUpdateRequest = (
  wire: IWireDisbursementFormData,
  version: 'v1' | 'v2'
) => ({
  id: wire.id,
  ...convertWireDisbursementFormDataToWireDisbursementRequest(wire, version),
});
